import { useMemo } from 'react';
import { useSubcategoryMap } from '@/features/categories/hooks/useSubcategoryMap';

export function useGroupedByCategory(entries) {
  const { map: subcategoryMap, categories } = useSubcategoryMap();
  
  return useMemo(() => {
    const grouped = {};
    
    entries.forEach(entry => {
      const mapEntry = subcategoryMap.get(String(entry.subcategory_id));      
      if (!mapEntry) {
        return;
      }
      
      const category = mapEntry.category;
      
      if (!grouped[category.id]) {
        grouped[category.id] = {
          category: category,
          entries: []
        };
      }
      grouped[category.id].entries.push(entry);
    });

    const result = [];
    
    categories.forEach(category => {
      if (grouped[category.id]) {
        result.push({
          category: category,
          entries: grouped[category.id].entries.sort((a, b) => a.ingredient_name.localeCompare(b.ingredient_name))
        });
      }
    });

    return result;
  }, [entries, categories, subcategoryMap]);
}
